import { LOAD_GOSPEL_HOME } from '@/store/protocols'

export default [
    {
        name: 'gospel',
        path: '',
        component: () => import('./Root.vue'),
        meta: {
            asyncData: LOAD_GOSPEL_HOME.join('/')
        }
    }
]
